import React from 'react'

function Navbar(props) {
    // const func =()=>{
    //     window.scrollTo(0,0); 
    // }
    return (
        <div>
            <nav className=" navbar navbar-expand-lg navbar-dark " style={{backgroundColor: "#064789"}}     onClick={(e) => { props.setDisplay('Home')}} >
                <div className="container-fluid">
                    <div className="navbar-brand" href="/"><img className='nvbar-img-logo' src="./image/logo.png" alt="dfv" /></div>
                    <h1 style={{color: "#ffffff"}}>PolyA2z</h1>
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">PolyA2z - Home</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body" >
                            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                <li className="nav-item ">
                                    <a className="nav-link" aria-current="page" href="/"  >Home</a>
                                </li>
                                <li className="nav-item ">
                                    <a className="nav-link" aria-current="page" href="/"  >{props.ver}</a>
                                </li>
                            </ul>
                            <form className="d-flex" role="search">
                                <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                                <button className="btn btn-outline-primary active" type="submit">Search</button>
                            </form>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar